import React from 'react';
import { MessageCircle, ExternalLink, Maximize2, Waves, Users, BedDouble, Bath, Car } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import { ASSETS, CONFIG } from '../data/villaData';

export default function Hero({ onBookClick }) {
  const { t } = useLanguage();

  const features = [
    { icon: Maximize2, label: t.quick.area },
    { icon: Waves, label: t.quick.pool },
    { icon: Users, label: t.quick.guests },
    { icon: BedDouble, label: t.quick.bedrooms },
    { icon: Bath, label: t.quick.bathroom },
    { icon: Car, label: t.quick.parking }
  ];

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img src={ASSETS.heroPool} alt="Moonlit Villa Pool" className="w-full h-full object-cover scale-105" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/80" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center text-white pt-20">
        <p className="text-sm md:text-base tracking-[0.4em] uppercase mb-6 font-light text-[#e9d4a8] animate-fade-in">
          {t.hero.tagline}
        </p>
        <h1 className="font-serif text-6xl md:text-8xl lg:text-9xl font-light mb-6 leading-none tracking-tight">
          {t.hero.title}
        </h1>
        <p className="text-lg md:text-2xl font-light mb-10 max-w-2xl mx-auto opacity-95">
          {t.hero.subtitle}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16">
          <button
            onClick={onBookClick}
            className="group inline-flex items-center gap-2 px-8 py-4 bg-[#25D366] hover:bg-[#1ebe5b] text-white font-semibold rounded-full shadow-2xl transition-all hover:scale-105"
          >
            <MessageCircle size={20} />
            {t.hero.cta}
          </button>
          <a
            href={CONFIG.bookingUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-2 px-8 py-4 bg-white/95 hover:bg-white text-stone-900 font-semibold rounded-full shadow-2xl transition-all hover:scale-105"
          >
            {t.hero.cta2}
            <ExternalLink size={18} />
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-6 gap-3 md:gap-4 max-w-4xl mx-auto">
          {features.map((f, i) => (
            <div key={i} className="backdrop-blur-md bg-white/10 border border-white/20 rounded-2xl px-3 py-4 flex flex-col items-center gap-2 hover:bg-white/20 transition-colors">
              <f.icon size={22} className="text-[#e9d4a8]" />
              <span className="text-xs md:text-sm font-medium">{f.label}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/60 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-2 bg-white/80 rounded-full" />
        </div>
      </div>
    </section>
  );
}
